// The imperial/metric setting.
//
// The browser keeps the active value in localStorage under 'gps-units' and
// announces changes with a 'gps-units-changed' window event; every page that
// shows units (GPS Licenses, Calibrations, Load Testing) reads it from there.
// App.js keeps that value in step with the user's account: the saved account
// value is applied at sign-in, and any change made in the browser is saved back.

export const UNITS_STORAGE_KEY = 'gps-units';
export const UNITS_CHANGE_EVENT = 'gps-units-changed';
export const UNIT_SYSTEMS = ['imperial', 'metric'];

export const isUnitSystem = (v) => UNIT_SYSTEMS.includes(v);

export function readUnitSystem() {
  try {
    return localStorage.getItem(UNITS_STORAGE_KEY) === 'metric' ? 'metric' : 'imperial';
  } catch {
    return 'imperial';
  }
}

export function writeUnitSystem(system) {
  try {
    localStorage.setItem(UNITS_STORAGE_KEY, system);
  } catch {
    // storage blocked: listeners still hear the change for this page view
  }
  window.dispatchEvent(new Event(UNITS_CHANGE_EVENT));
}
